// @ts-nocheck

export const replaceValueAtKeyPath = (
	obj = {},
	[first, ...rest]: any,
	value
) => {
	if (Array.isArray(obj)) {
		let newArray = [...obj]
		newArray?.splice(
			first as number,
			1,
			rest?.length ? replaceValueAtKeyPath(obj?.[first], rest, value) : value
		)
		return newArray
	} else {
		return {
			...obj,
			[first]: rest?.length
				? replaceValueAtKeyPath(obj?.[first], rest, value)
				: value,
		}
	}
}
